import { render, staticRenderFns } from "./HomePartners.vue?vue&type=template&id=27bd093f&scoped=true"
import script from "./HomePartners.vue?vue&type=script&lang=js"
export * from "./HomePartners.vue?vue&type=script&lang=js"
import style0 from "./HomePartners.vue?vue&type=style&index=0&id=27bd093f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bd093f",
  null
  
)

export default component.exports